import ApplicationElementManager from './view/ApplicationElementManager';
class Application {
  appName = '';
  dirty = false;
  initialized = false;
  title = '';
  constructor(appId, url, createHTMLElement) {
    this.appId = appId;
    this.url = url;
    this.appName = appId;
    this.elementManager = new ApplicationElementManager(this);
    this.htmlElement = this.elementManager.getHTMLElement(createHTMLElement);
  }
  hide() {
    this.elementManager.hideHTMLElement();
  }
  show() {
    this.elementManager.showHTMLElement();
  }
  init(useTransitionSplash) {
    this.elementManager.initHTMLElement(this.url, useTransitionSplash);
    this.initialized = true;
  }
  isInitialized() {
    return this.initialized;
  }
  isLoaded() {
    return this.elementManager.isLoaded();
  }
  getHTMLElement() {
    return this.htmlElement;
  }
  getWindow() {
    return this.elementManager.getWindow();
  }
  queueMessage(message, executePostMessage) {
    this.elementManager.queueMessage(message, executePostMessage);
  }
}
export default Application;
//# sourceMappingURL=Application.js.map